import React, { useEffect, useState } from "react";
import { Splide, SplideSlide } from '@splidejs/react-splide';
import "./../LibSplide/LibSplide.scss";
import api from "api";
import _ from "lodash";
import { Link } from "react-router-dom";
import update from "immutability-helper";
import "./style.scss";

const PagesList = (props) => {
    return (
        <div className="pages-list-items">
            {
                props.pages !== false && props.pages.map((page) => (
                    <div key={page.PageID} className="pages-item">
                        <div className="pages-item-wrapper relative">
                            <Link to={`/page/${page.PageSlug}`} className="image-box cover square rounded">
                                <img src={page.PagePhoto}/>
                            </Link>
                            <span className="block text-sm bold mt-sm text-center leading-text">{page.PageName}</span>
                        </div>
                    </div>
                ))
            }
        </div>
    )
}

const PagesListSlider = (props) => {
    const [isEOF, setIsEOF]             = useState(false);
    const [isLoading, setIsLoading]     = useState(true);
    const [pages, setPages]             = useState(props.pages || false);
    const [listArgs, setListArgs]       = useState(_.assignIn({}, props.pages_args, {
        posts_per_page : 5
        ,paged : 1
    }) || {});

    useEffect(() => {
        setIsLoading(true);
        api( props.endpoint ? props.endpoint :  '/Pages', 'get', listArgs, props.token || '').then(response => {
            setIsLoading(false);

            if(response.page.length < listArgs.posts_per_page)
            {
                setIsEOF(true);
            }

            if(pages !== false)
            {
                setPages( pages.concat(response.page));
            }
            else
            {
                setPages( response.page );
            }
            
        })
        .catch(() => {
            setIsLoading(false);
            setIsEOF(true);
        })

    }, [listArgs]);

    return (
        <div className="pages-list-slider">
            {
                <Splide options={{
                    autoWidth : true
                    ,pagination : false
                    ,arrows : false
                }}>
                    {
                        pages !== false && pages.map((page) => (
                            <SplideSlide key={page.PageID}>
                                <div className="pages-item">
                                    <div className="pages-item-wrapper relative">
                                        <Link to={`/page/${page.PageSlug}`} className="image-box cover square rounded">
                                            <img src={page.PagePhoto}/>
                                        </Link>
                                        <span className="block text-sm bold mt-sm text-center leading-text">{page.PageName}</span>
                                    </div>
                                </div>
                            </SplideSlide>
                        ))
                    }
                    {
                        isLoading && 
                        <SplideSlide>
                            <div className="pages-item">
                                <div className="card-skeleton pages-item-wrapper shadow relative">
                                    <span className="skeleton"></span>
                                </div>
                            </div>
                        </SplideSlide>
                    }
                    {
                        !isEOF && !isLoading &&
                        <SplideSlide>
                            <div className="pages-item">
                                <div className="card-load-more pages-item-wrapper shadow relative">
                                    <button className="load-more-card" onClick={e => {
                                        e.preventDefault();
                                        setListArgs(
                                            update(listArgs, {
                                                paged : {
                                                    $set : listArgs.paged ? listArgs.paged + 1 : 2
                                                }
                                            })
                                        );
                                    }}><span>Load More</span></button>
                                </div>
                            </div>
                        </SplideSlide>
                    }
                    {
                        pages !== false && pages.length == 0 &&
                        <SplideSlide>
                            <div className="pages-item">
                                <div className="card-not-found pages-item-wrapper shadow relative">
                                    <span className="text-center bold block mt-4">
                                        No Pages Found
                                    </span>
                                </div>
                            </div>
                        </SplideSlide>
                    }
                </Splide>
            }
        </div>
    )
}

export { PagesListSlider, PagesList }